import { useCallback } from "react";

/**
 * Hook para salvar e carregar listas de objetos no localStorage usando apenas os IDs.
 *
 * @param {string} key - A chave do localStorage.
 * @returns {{
 *   save: (items: { id: string }[]) => void,
 *   load: () => string[]
 *   remove: (idToRemove: string) => void
 *   clear: () => void
 * }}
 */
const useLocalStorage = (key) => {
  const save = useCallback(
    (items, allStructure = false) => {
      try {
        if (allStructure) {
          localStorage.setItem(key, JSON.stringify(items));
          return;
        }

        const ids = items.map((item) => item.id);
        localStorage.setItem(key, JSON.stringify(ids));
      } catch (error) {
        console.error("Erro ao salvar no localStorage:", error);
      }
    },
    [key],
  );

  const load = useCallback(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error("Erro ao carregar do localStorage:", error);
      return [];
    }
  }, [key]);

  const remove = useCallback(
    (idToRemove) => {
      try {
        const stored = localStorage.getItem(key);
        const ids = stored ? JSON.parse(stored) : [];
        const updated = ids.filter((id) => id !== idToRemove);
        localStorage.setItem(key, JSON.stringify(updated));
      } catch (error) {
        console.error("Erro ao remover ID do localStorage:", error);
      }
    },
    [key],
  );

  const clear = useCallback(() => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Erro ao limpar o localStorage:", error);
    }
  }, [key]);

  return { save, load, remove, clear };
};

export default useLocalStorage;
